// extracted by mini-css-extract-plugin
export default {"button":"TicketJoinWaitlistButton-rebranding-module__button___3m0JV"};